// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingSpinner_container__QulY_","text":"LoadingSpinner_text__O5kSf","spinner":"LoadingSpinner_spinner__ksm1C"};